/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Effect from '../Effects/Effect';
import EffectSequence from '../Effects/EffectSequence';
import Currency from '../Localization/Currency';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * A special version of [[EffectSequence]] that triggers when certain award thresholds
 * have been reached on a winning spin.
 */
@cc._decorator.ccclass
export default class WinCelebration extends EffectSequence
{
    /** The bet multiplier that much be reached to trigger this win celebration. */
    @property({ type: cc.Integer, visible: true })
    private _thresholdMultiplier: number = 0;
    /** Accessor for the threshold multiplier. */
    public get ThresholdMultiplier(): number { return this._thresholdMultiplier; }

    /**
     * Returns the award threshold to be met to trigger this win celebration.
     * @param currentBet The current wager placed on this spin.
     * @returns The supplied wager times the threshold multiplier in millicents.
     */
    public GetWinLevelMC(currentBet: Currency): number
    {
        return this._thresholdMultiplier * currentBet.GetValue();
    }

    /**
     * Stops the win celebration in progress.
     */
    public Stop(): void
    {
        super.Stop();
        // this.EffectManager.States[this.EffectManager.States.length - 1].getComponent(Effect).Trigger();
    }

    /**
     * Manually triggers the win celebration.
     */
    public Trigger = (): void =>
    {
        this.trigger();
    }

    /**
     * Manually triggers the win celebration.
     * @param onComplete Handler to be called when the celebration is complete.
     */
    public TriggerWithHandler(onComplete: () => any): void
    {
        this.EffectManager.OnComplete(onComplete);

        super.trigger();
    }
}
